var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransportation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.49711 16.7641C8.4943 16.9354 8.4715 17.1062 8.42971 17.2724C8.31091 17.6574 8.07377 17.9949 7.75198 18.2375C7.4302 18.4801 7.0405 18.6148 6.63758 18.6232C6.23359 18.6235 5.84044 18.4919 5.5185 18.2477C5.19656 18.0037 4.96319 17.6615 4.85435 17.2724C4.80478 17.1075 4.77888 16.9362 4.77759 16.7641C4.77759 16.2709 4.97365 15.7976 5.32239 15.4489C5.67113 15.1002 6.14439 14.9041 6.63758 14.9041C7.13078 14.9041 7.60357 15.1002 7.95231 15.4489C8.30105 15.7976 8.49711 16.2709 8.49711 16.7641Z",
    stroke: "currentColor",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7934 16.8319C18.7906 16.9974 18.7682 17.1622 18.7265 17.3226C18.6152 17.6975 18.3806 18.0269 18.058 18.2616C17.7355 18.4963 17.3424 18.6232 16.9385 18.6232C16.5346 18.6232 16.1419 18.4963 15.8194 18.2616C15.4969 18.0269 15.2623 17.6975 15.151 17.3226C15.1046 17.1631 15.0817 16.9977 15.0836 16.8319C15.0653 16.5859 15.0999 16.3388 15.1847 16.1062C15.2697 15.8736 15.4034 15.6605 15.5775 15.4799C15.7514 15.2994 15.9619 15.1554 16.1962 15.057C16.4304 14.9586 16.6831 14.908 16.9385 14.908C17.1939 14.908 17.4466 14.9586 17.6808 15.057C17.915 15.1554 18.126 15.2994 18.3 15.4799C18.4741 15.6605 18.6078 15.8736 18.6927 16.1062C18.7776 16.3388 18.8117 16.5859 18.7934 16.8319Z",
    stroke: "currentColor",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0828 16.7642H8.49756",
    stroke: "currentColor",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.52773 16.8212H4.23053C3.68141 16.8212 3.15478 16.6029 2.76649 16.2147C2.37821 15.8264 2.15991 15.2997 2.15991 14.7506V7.44732C2.15991 6.8982 2.37821 6.37158 2.76649 5.98328C3.15478 5.595 3.68141 5.37671 4.23053 5.37671H16.6916C16.982 5.3776 17.2682 5.44839 17.5252 5.58358C17.7822 5.71877 18.0025 5.91393 18.1678 6.15272L21.0435 10.2743C21.2521 10.5826 21.3625 10.9477 21.3599 11.3198L21.3116 14.7506C21.3129 15.0221 21.2606 15.2914 21.1576 15.5425C21.0546 15.7937 20.9031 16.0223 20.7116 16.2147C20.5201 16.4071 20.2925 16.5598 20.0418 16.664C19.7912 16.7681 19.5223 16.8212 19.2509 16.8212H18.9345",
    stroke: "currentColor",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.05 11.751H21.3319",
    stroke: "currentColor",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25562 11.751H10.24",
    stroke: "currentColor",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.05 5.43384V16.7639",
    stroke: "currentColor",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransportation);
export default __webpack_public_path__ + "static/media/transportation.3c11abd39eb19ed2725b0b5e5a65bccc.svg";
export { ForwardRef as ReactComponent };